export default "__VITE_ASSET__3fd706cd__"